/**
 * Action types for the Call Management & UX feature.
 */
// Call Waiting
export const CALL_WAITING_INCOMING = 'CALL_WAITING_INCOMING';
export const CALL_WAITING_RESPONDED = 'CALL_WAITING_RESPONDED';
export const CALL_WAITING_DISMISS = 'CALL_WAITING_DISMISS';
// A call this device put on hold to answer another (callWaitingSwitch.ts)
export const HELD_CALL_SET = 'HELD_CALL_SET';
export const HELD_CALL_CLEARED = 'HELD_CALL_CLEARED';
// Incoming P2P call (not already on a call) — web deaf-accessible ring
export const INCOMING_P2P_CALL = 'INCOMING_P2P_CALL';
export const INCOMING_P2P_CLEAR = 'INCOMING_P2P_CLEAR';
// Call Hold
export const CALL_HOLD_UPDATED = 'CALL_HOLD_UPDATED';
export const CALL_ON_HOLD = 'CALL_ON_HOLD';
export const CALL_OFF_HOLD = 'CALL_OFF_HOLD';
// Conference (3-way)
export const CONFERENCE_INVITE = 'CONFERENCE_INVITE';
export const CONFERENCE_ADD_RINGING = 'CONFERENCE_ADD_RINGING';
export const CONFERENCE_REMOVED = 'CONFERENCE_REMOVED';
export const CONFERENCE_PARTICIPANT_REMOVED = 'CONFERENCE_PARTICIPANT_REMOVED';
// In-call Chat
export const CHAT_MESSAGE_RECEIVED = 'CHAT_MESSAGE_RECEIVED';
export const CHAT_MESSAGE_SENT = 'CHAT_MESSAGE_SENT';
export const CHAT_HISTORY_LOADED = 'CHAT_HISTORY_LOADED';
export const CHAT_PANEL_TOGGLE = 'CHAT_PANEL_TOGGLE';
// Client Preferences
export const PREFERENCES_UPDATED = 'PREFERENCES_UPDATED';
export const DND_TOGGLED = 'DND_TOGGLED';
export const DARK_MODE_CHANGED = 'DARK_MODE_CHANGED';
// P2P Target DND
export const P2P_TARGET_DND = 'P2P_TARGET_DND';
